export const environment = {
  APIKey    : 'a6d35cef8c71363bfb0976fa351bcda2',
  APIUrl    : 'https://test-hubs.3dissue.com',
  production: false,
  isLocal   : true,
};



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/environments/environment.ts